

































































































import { Component, Mixins } from 'vue-property-decorator'

import {
  mdiEmailOutline,
  mdiFileDocumentOutline,
  mdiHomeAccount,
  mdiAccountOutline,
  mdiEye,
  mdiLogout,
  mdiChevronDown,
  mdiPhoneOutline,
  mdiHeadphones,
} from '@mdi/js'

import { security } from '@/store/modules/security'
import { notifications } from '@/store/modules/notifications'
import { settings } from '@/store/modules/settings'
import { support } from '@/store/modules/support'
import { Navigator } from '@/mixins/Navigator'

import NotificationBar from '@/components/layouts/app/NotificationBar.vue'
import FeedbackDialog from '@/components/lib/FeedbackDialog.vue'

import { mock } from '@/tools'

@Component({
  components: {
    NotificationBar,
    FeedbackDialog,
  },
})
class AppTemplate extends Mixins<Navigator>(Navigator) {
  securityModule = security.context(this.$store)
  notificationsModule = notifications.context(this.$store)
  settingsModule = settings.context(this.$store)
  supportModule = support.context(this.$store)

  icons = {
    mdiFileDocumentOutline,
    mdiEmailOutline,
    mdiHomeAccount,
    mdiChevronDown,
    mdiAccountOutline,
    mdiEye,
    mdiLogout,
    mdiPhoneOutline,
    mdiHeadphones,
  }
  htmlTag = document.documentElement

  isShowFeedbackDialog = false

  get phone() {
    return this.supportModule.state.phone
  }

  async created() {
    await this.notificationsModule.actions.enableCheckNotificationsLoop(true).catch(mock)
  }

  get portalLink() {
    return process.env.VUE_APP_PORTAL_LINK
  }

  async logout() {
    await this.$router.push({ name: 'logout' }).catch(mock)
  }
}

export default AppTemplate
